namespace SorAraBul.Definitions {
    export interface TownsForm {
        CityCountryId: Serenity.ServiceLookupEditor;
        CityId: Serenity.ServiceLookupEditor;
        Name: Serenity.StringEditor;
    }

    export class TownsForm extends Serenity.PrefixedContext {
        static formKey = 'Definitions.Towns';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!TownsForm.init)  {
                TownsForm.init = true;

                var s = Serenity;
                var w0 = s.ServiceLookupEditor;
                var w1 = s.StringEditor;

                Q.initFormType(TownsForm, [
                    'CityCountryId', w0,
                    'CityId', w0,
                    'Name', w1
                ]);
            }
        }
    }
}
